import * as React from 'react'
import classNames from 'classnames'

import { Text, TextName } from '../text/Text'
import { Button } from '../button/Button'

import classes from './style.module.scss'

interface ComponentProps {
  className?: string
  title: string
  buttonText: string
  onButtonClick?: () => void
  background: string
}

export const ExploreProductCard: React.FC<ComponentProps> = (props) => {
  const { className, title, buttonText, onButtonClick, background } = props

  return (
    <div className={classNames(classes.container, className)} style={{ backgroundImage: `url(${background})` }}>
      <div className={classes.content}>
        <Text type={TextName.TextBold} className={classes.title}>{title}</Text>
        <Button as='button' onClick={onButtonClick}>
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

ExploreProductCard.defaultProps = {
  className: undefined,
}
